import i18n from 'i18n';
import { COMMON_GRID_COLUMN_FIELD_NAMES } from 'shared/commonGrid/grid-enums';
import { ColGroupDef } from '@ag-grid-enterprise/all-modules';
import { UtimacoPacketSwitch } from 'data/utimacoPacketSwitch/utimacoPacketSwitch.types';

export enum UtimacoPacketSwitchActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newUtimacoPacketSwitch: UtimacoPacketSwitch = {
  id: '',
  AFID: '',
  CFID: '',
  LEA: '',
  MCTYPE: '',
  IPADDR: '',
  PORT: '',
};

export const distributorColumnDefs: ColGroupDef[] = [
  {
    headerName: '',
    children: [
      {
        headerName: i18n.t('utimacoPacketSwitch.grid.lea'),
        field: 'LEA',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'LEA',
        flex: 1,
        minWidth: 198,
      },
      {
        headerName: i18n.t('utimacoPacketSwitch.grid.accessFunction'),
        field: 'AFID',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'AFID',
        flex: 1,
        minWidth: 198,
      },
      {
        headerName: i18n.t('utimacoPacketSwitch.grid.collectionFunction'),
        field: 'CFID',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'CFID',
        flex: 1,
        minWidth: 198,
      },
      {
        headerName: i18n.t('utimacoPacketSwitch.grid.iPAddress'),
        field: 'IPADDR',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'IPADDR',
        flex: 1,
        minWidth: 198,
      },
      {
        headerName: i18n.t('utimacoPacketSwitch.grid.port'),
        field: 'PORT',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'PORT',
        flex: 1,
        minWidth: 198,
      },
    ],
  },
];
